/**
 * Responsibility: describe the needle aircraft as a wireframe vertex and edge list.
 *
 * A long, narrow interceptor. Chosen to contrast with the default delta in the one way that reads
 * from a chase camera: **silhouette width**. Two aircraft of similar proportions would be
 * indistinguishable at the size they occupy on screen, so the alternates differ in outline rather
 * than in detail.
 *
 * Model space matches `default.js`: nose down negative Z, +Y up, +X the right wing, roughly two
 * units long.
 */

export const needleAircraft = {
  id: 'needle',
  label: 'Needle',

  vertices: [
    [0, 0, -1.25], // 0 nose
    [-0.28, 0, -0.15], // 1 left forward shoulder
    [0.28, 0, -0.15], // 2 right forward shoulder
    [-0.5, 0, 0.72], // 3 left wingtip, swept well back
    [0.5, 0, 0.72], // 4 right wingtip
    [0, 0, 0.55], // 5 tail root
    [0, 0.34, 0.7], // 6 fin tip
    [0, -0.2, 0.3], // 7 belly keel
  ],

  edges: [
    // A narrow fuselage spine, which is what makes this read as thin from behind.
    [0, 1],
    [0, 2],
    [1, 5],
    [2, 5],
    // Swept wings, attached at the shoulders rather than the nose.
    [1, 3],
    [2, 4],
    [3, 5],
    [4, 5],
    // Fin.
    [5, 6],
    [0, 6],
    // Keel, so roll is legible from directly behind.
    [0, 7],
    [5, 7],
  ],
};
